import React from 'react';
import {
  Dialog,
  AppBar,
  Toolbar,
  makeStyles,
  createStyles,
  Theme,
  Typography,
  IconButton,
  Grid,
} from '@material-ui/core';
import { colors } from 'design-system';
import { XCircle } from 'react-feather';
import Summary from '../../Summary';

type Props = {
  open: boolean;
  onCloseRequested: () => void;
  optionSelected: number;
  optionTitle: string | undefined;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    contentWrappingDialog: {
      marginTop: theme.spacing(2),
      padding: theme.spacing(2),
    },
    dialoguePaperStyle: {
      background: '#f9f9f9',
    },
    appDialogBar: {
      backgroundColor: colors.white,
    },
    appDialogBarOffset: theme.mixins.toolbar,
    closeIcon: {
      top: theme.spacing(2),
      right: theme.spacing(2),
      position: 'absolute',
    },
  }),
);

const PolicySummaryDetailsDialogue = ({
  open,
  onCloseRequested,
  optionSelected,
  optionTitle,
}: Props): JSX.Element => {
  const classes = useStyles();

  return (
    <Dialog
      data-testid="summary-details-dialog"
      open={open}
      fullScreen
      PaperProps={{
        className: classes.dialoguePaperStyle,
      }}
    >
      <AppBar position="fixed" className={classes.appDialogBar} elevation={0}>
        <Toolbar>
          <Grid container justifyContent="center">
            <Typography variant="body1" data-testid="details-title">
              {optionTitle}
            </Typography>
          </Grid>
        </Toolbar>
        <IconButton
          data-testid="close-button"
          className={classes.closeIcon}
          onClick={onCloseRequested}
        >
          <XCircle color={colors.madison} />
        </IconButton>
      </AppBar>

      <div className={classes.appDialogBarOffset} />
      <div className={classes.contentWrappingDialog}>
        <Grid container spacing={2}>
          <Grid item xs={12} container justifyContent="center">
            <Summary
              data-testid="policy-summary-details"
              onSubmit={(): void => {}}
              collapsibleCards
              isOptionsDetails
              optionSelected={optionSelected}
            />
          </Grid>
        </Grid>
      </div>
    </Dialog>
  );
};

export default PolicySummaryDetailsDialogue;
